import { createFileRoute } from "@tanstack/react-router";
import { AdminStockManagement } from "@/components/admin/AdminStockManagement";

export const Route = createFileRoute("/admin/stock")({
  component: AdminStockManagement,
});
